import React from 'react';
import { Users, Settings, Shield } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const AdminPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div data-testid="admin-page">
      <div className="bg-white rounded-lg shadow-sm p-6 mb-6 border border-gray-200">
        <h2 className="text-2xl font-bold text-gray-800 mb-2" style={{ fontFamily: 'Inter, sans-serif' }}>
          Admin Panel
        </h2>
        <p className="text-gray-600">Manage users, roles, and system settings</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="bg-white rounded-lg shadow-sm p-6 border border-gray-200 hover:shadow-md transition">
          <div className="flex items-center space-x-4 mb-4">
            <div className="bg-blue-100 p-3 rounded-lg">
              <Users className="text-blue-600" size={24} />
            </div>
            <div>
              <h3 className="font-semibold text-gray-800">User Management</h3>
              <p className="text-sm text-gray-600">Manage users and roles</p>
            </div>
          </div>
          <button
            onClick={() => navigate('/admin/users')}
            className="w-full bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700 transition"
            data-testid="navigate-users-btn"
          >
            Manage Users
          </button>
        </div>

        <div className="bg-white rounded-lg shadow-sm p-6 border border-gray-200 hover:shadow-md transition">
          <div className="flex items-center space-x-4 mb-4">
            <div className="bg-green-100 p-3 rounded-lg">
              <Settings className="text-green-600" size={24} />
            </div>
            <div>
              <h3 className="font-semibold text-gray-800">Settings</h3>
              <p className="text-sm text-gray-600">Global system settings</p>
            </div>
          </div>
          <button
            onClick={() => navigate('/admin/settings')}
            className="w-full bg-green-600 text-white py-2 rounded-lg hover:bg-green-700 transition"
            data-testid="navigate-settings-btn"
          >
            Global Settings
          </button>
        </div>
      </div>
    </div>
  );
};

export default AdminPage;